export enum CustomerType {
  COMMERCIAL = 'COMMERCIAL',
  RESIDENTIAL = 'RESIDENTIAL',
}

export enum IndustryType {
  AUTOMOTIVE = 'AUTOMOTIVE',
  CONSTRUCTION = 'CONSTRUCTION',
  EDUCATION = 'EDUCATION',
  GROCERY_AND_CONVENIENCE = 'GROCERY_AND_CONVENIENCE',
  HEALTHCARE = 'HEALTHCARE',
  HOSPITALITY = 'HOSPITALITY',
  MANUFACTURING = 'MANUFACTURING',
  PROFESSIONAL_SERVICES = 'PROFESSIONAL_SERVICES',
  PROPERTY_MANAGEMENT = 'PROPERTY_MANAGEMENT',
  RESTAURANT = 'RESTAURANT',
  RETAIL = 'RETAIL',
  WHOLESALE = 'WHOLESALE',
}

export enum IndustryWeight {
  HEAVY = 'Heavy',
  MEDIUM = 'Medium',
  LIGHT = 'Light',
}

export interface ServiceContext {
  infoProDivisionCodes: string[];
  lawsonDivisionCodes: string[];
  latitude?: number;
  longitude?: number;
  rdhAccountIds: string[];
  serviceAddress?: ServiceAddress;
  serviceContextId: string;
  timeZoneCode?: string;
  timeZoneName?: string;
}

export interface ServiceAddress {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  postalCode: string;
  stateCode: string;
  countryCode?: string;
  latitude?: number;
  longitude?: number;
  timeZoneCode?: string;
  timeZoneName?: string;
}

export interface ServiceContextResponse {
  serviceAddress: ServiceAddress;
  infoProDivisionCodes: string[];
  lawsonDivisionCodes: string[];
  rdhAccountIds: string[];
  serviceContextId: string;
}
